<template>
    <div class="unpack-right">
        <RightClassify :chapterId="detailData.id" v-if="type === 'classify'" @unpack="unpack" />
        <!-- <RightMimic :chapterId="detailData.id" v-if="type === 'mimic'" @unpack="unpack" /> -->
        <RightResult :chapterId="detailData.id" :result="detailData.result" v-if="type === 'result'" @unpack="unpack" />
            
    </div>
</template>
<script>
import RightClassify from '@/components/novelTurnScript/manage/right_classify.vue'
// import RightMimic from '@/components/novelTurnScript/manage/right_mimic.vue'
import RightResult from '@/components/novelTurnScript/manage/right_result.vue'
export default {
    components: {
        RightClassify,
        RightResult,
        // RightMimic
    },
    data() {
        return {
            type: ''
        }
    },
    props: {
        detailData: {
            type: Object,
            default() {
                return {}
            }
        }
    },
    methods: {
        unpack(tab) {
            this.type = tab
        },
        tabs(text) {
            if (text) {
                this.type = 'result'
            } else {
                this.type = 'classify'
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.unpack-right {
    width: 45.9vw;
    font-family: Microsoft YaHei, Microsoft YaHei;
    background-color: #ffffff;
    border-radius: 8px 8px 0px 0px;
    box-shadow: 0px 0px 8px 0px rgba(117, 53, 0, 0.06);
    display: flex;
}
</style>